<script setup lang="ts">
import BaseButton from './BaseButton.vue';

const show = defineModel('show', { type: Boolean, default: false })

const appStoreUrl = 'https://apps.apple.com/app/id6746178648';

const openAppStore = () => {
  window.open(appStoreUrl, '_blank', 'noopener,noreferrer');
};

const dismissNotice = () => {
  show.value = false;
};
</script>

<template>
  <div v-if="show" class="p-4 border border-amber-500/30 bg-amber-500/10 rounded-lg">
    <h3 class="text-amber-400 text-sm font-medium mb-2">
      iOS MIDI Support Notice
    </h3>
    <p class="text-text-secondary text-sm mb-3">
      Safari on iOS doesn't support MIDI devices. For the best experience with your MIDI drum kit, please download our iOS app.
    </p>
    <div class="flex items-center gap-3">
      <BaseButton 
        color="surface"
        size="sm" 
        class="flex-1"
        @click="openAppStore"
      >
        <span>Download iOS App</span>
      </BaseButton>
      <BaseButton 
        variant="outlined" 
        size="sm" 
        class="flex-1"
        @click="dismissNotice"
      >
        <span>Continue on Web</span>
      </BaseButton>
    </div>
  </div>
</template> 